<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		*ngIf="!isR104"
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary {{ sectionclass }}"
		style="position: relative"
	>
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
			style="position: relative"
			*ngIf="campaignCarouselItem"
		>
			<div class="o-stack__cell">
				<h5 *ngIf="hasData" class="lift-title">
					<span class="lift-trend-class">Lift Trend:</span> {{ campaignCarouselItem.name }}
				</h5>
			</div>
			<!-- carousel icons start -->
			<div class="o-stack__cell carousel-width_p2">
				<div class="o-stack o-stack&#45;&#45;center o-stack&#45;&#45;nowrap o-stack&#45;&#45;tinyGap u-font-small">
					<div
						class="o-stack__cell u-relative"
						style="position: absolute; left: 93%; top: 5px"
						*ngIf="campaignsList.length > 1"
					>
						<a class="c-icon c-icon&#45;&#45;main u-color-minor u-opacity-50p">
							<span class="next" (click)="prevArrow()" class="carousel-arrow-style">
								<i class="fa fa-angle-left" aria-hidden="true"></i>
							</span>
						</a>
						<a class="c-icon c-icon&#45;&#45;main u-color-minor u-opacity-50p" style="margin-left: 5px">
							<span class="prev" (click)="nextArrow()" class="carousel-arrow-style">
								<i class="fa fa-angle-right" aria-hidden="true"></i>
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- carousel icons end -->
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom lift-trend-no-data-header"
			style="position: relative; font-size: 1.1em"
			*ngIf="!campaignCarouselItem"
		>
			Lift Trends
		</div>
		<div>
			<div class="c-portlet__content u-pt-small" style="width: 100%" *ngIf="campaignCarouselItem">
				<div class="o-stack o-stack--center o-stact_ImgSpecs" style="height: auto">
					<div class="charts-container product-lift-chart-container" style="margin: 0 auto">
						<div class="chart-layout">
							<div [id]="'campaign' + i" class="individual-chart" style="min-height: 200px">
								<app-chart class="individual-chart" [chartData]="campaignCarouselItem"></app-chart>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="c-portlet__content u-pt-small lift-trend-no-data-body"
				style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%"
				*ngIf="!campaignCarouselItem"
			>
				<img [src]="placeholderimage" class="lift-trend-no-data-placeholder" style="width: 80%" />
			</div>
		</div>
	</div>
	<div
		*ngIf="isR104 && hasData"
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary {{ sectionclass }}"
		style="position: relative"
	>
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
			style="position: relative"
			*ngIf="campaignCarouselItem"
		>
			<div class="o-stack__cell">
				<h5 *ngIf="hasData" class="lift-title">
					<span class="lift-trend-class">Lift Trend:</span> {{ campaignCarouselItem.name }}
				</h5>
			</div>
			<!-- carousel icons start -->
			<div class="o-stack__cell carousel-width_p2">
				<div class="o-stack o-stack&#45;&#45;center o-stack&#45;&#45;nowrap o-stack&#45;&#45;tinyGap u-font-small">
					<div
						class="o-stack__cell u-relative"
						style="position: absolute; left: 93%; top: 5px"
						*ngIf="campaignsList.length > 1"
					>
						<a class="c-icon c-icon&#45;&#45;main u-color-minor u-opacity-50p">
							<span class="next" (click)="prevArrow()" class="carousel-arrow-style">
								<i class="fa fa-angle-left" aria-hidden="true"></i>
							</span>
						</a>
						<a class="c-icon c-icon&#45;&#45;main u-color-minor u-opacity-50p" style="margin-left: 5px">
							<span class="prev" (click)="nextArrow()" class="carousel-arrow-style">
								<i class="fa fa-angle-right" aria-hidden="true"></i>
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- carousel icons end -->
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom lift-trend-no-data-header"
			style="position: relative; font-size: 1.1em"
			*ngIf="!campaignCarouselItem"
		>
			Lift Trends
		</div>
		<div>
			<div class="c-portlet__content u-pt-small" style="width: 100%" *ngIf="campaignCarouselItem">
				<div class="o-stack o-stack--center o-stact_ImgSpecs" style="height: auto">
					<div class="charts-container product-lift-chart-container" style="margin: 0 auto">
						<div class="chart-layout">
							<div [id]="'campaign' + i" class="individual-chart" style="min-height: 200px">
								<app-chart class="individual-chart" [chartData]="campaignCarouselItem"></app-chart>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="c-portlet__content u-pt-small lift-trend-no-data-body"
				style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%"
				*ngIf="!campaignCarouselItem"
			>
				<img [src]="placeholderimage" class="lift-trend-no-data-placeholder" style="width: 80%" />
			</div>
		</div>
	</div>
	<div class="no-data-container" *ngIf="!hasData">
		<div
			class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs {{
				sectionclass
			}}"
			style="position: relative"
		>
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
				style="position: relative"
			>
				<div class="o-stack__cell">
					<h5>Lift Trend</h5>
				</div>
			</div>
		</div>
		<div class="map-no-data">No Data to Display</div>
	</div>
</div>
